import React, { useState, useEffect, useLayoutEffect } from 'react';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import withAlert from '../../hoc/withAlerts'
import Loading from './parts/Loading'
import endpoints, { apiRequest } from '../../endpoints';
import axios from 'axios';
import {storage} from '../../storage';
import { useSelector, useDispatch } from 'react-redux'
import { setHeader } from '../../redux/headerSlice'
import Confirmation from './modals/Confirmation';
import Warning from './modals/Warning';
import DOMPurify from 'dompurify';
import AutoreplyTestModal from './modals/AutoreplyTestModal'
import AutoreplyDetailsModal from './modals/AutoreplyDetailsModal'
import AutoreplySettingsModal from './modals/AutoreplySettingsModal'
import AddBoxIcon from '@mui/icons-material/AddBoxRounded';
import GoogleIcon from '@mui/icons-material/Google';
import BugReportIcon from '@mui/icons-material/BugReportRounded';
import ScheduleIcon from '@mui/icons-material/ScheduleRounded';
import ReplayIcon from '@mui/icons-material/ReplayRounded';
import AutoreplyTable from './tables/AutoreplyTable';
import Grow from '@mui/material/Grow';

let authWindow = false
let authWindowInterval = null

function AutoreplyEmail(props) {
    const [list, setList] = useState(null)
    const [pagination, setPagination] = useState({
        page: 1,
        perpage: 10,
        total: 0
    })
    const [perpage, setPerpage] = useState(storage.autoreply.perpage);
    const [loading, setLoading] = useState(false);
    const [deleteItem, setDeleteItem] = useState()
    const [warningText, setWarningText] = useState()
    const [test, setTest] = useState()
    const [detailsItem, setDetailsItem] = useState()
    const [gmailCheck, setGmailCheck] = useState()
    const [gmailExpiry, setGmailExpiry] = useState()
    const [workTime, setWorkTime] = useState()
    const [confirmLogout, setConfirmLogout] = useState(false)
    
    const dispatch = useDispatch()
    
    const token = useSelector((state) => state.auth.token)
    
    const rawMarkup = (content) => {
        var rawMarkup = content
        return { __html: DOMPurify.sanitize(rawMarkup) };
    }
    
    const getList = async (page) => {
        storage.autoreply.perpage = perpage;
        
        const params = {}
        if (page) {
            params.page = page
        }
        if (perpage) {
            params.perpage = perpage
        }

        setLoading(true)
        try {
            const res = await apiRequest('get', endpoints.autoreply, {
                token: token,
                ...params
            })
            
            setList(res.data.items)
            setPagination({
                page: res.data.page + 1,
                perpage: res.data.perpage,
                total: res.data.total,
                pages: Math.ceil(res.data.total / res.data.perpage)
            })
        } catch (e) {
            setList([])
            showAlertError('Unknown Error - get list')
        }
        setLoading(false)
    }
    
    const handlePaginate = (value) => {
        window.scrollTo(0, 0)
        getList(value)
    }

    const refreshHandler = async () => {
        await getList(pagination.page - 1)
    }

    const handleChangePerpage = (value) => {
        setPerpage(value)
    }
    
    const deleteHandle = async (response) => {
        if (response) {
            try {
                await apiRequest('delete', endpoints.autoreply_delete, {
                    token: token,
                    id: deleteItem.id,
                })
                await getList()
                showAlertSuccess('Item deleted successfully!')
            } catch (e) {
                showAlertError('Unknown Error - delete Item')
            }
        }
        setDeleteItem(null)
    }
    
    const gmailLoginHandle = async () => {
        try {
            const res = await apiRequest('get', endpoints.autoreply_gmail_login, {
                token: token,
            })
            console.log(res)
            let left = (window.screen.width - 600) / 2
            let top = (window.screen.height - 750) / 2
            authWindow = window.open(res.data.oauthUrl, 'gmailAuthLogin', 'left=' + left + ',top=' + top + ',width=600,height=750')
        } catch (e) {
            showAlertError('Unknown Error - Login Error')
        }
    }
    
    const confirmLogoutHandle = async (response) => {
        if (response) {
            try {
                const res = await apiRequest('get', endpoints.autoreply_gmail_logout, {
                    token: token,
                })
                showAlertSuccess('Logout Was Successful')
                getGmailCheck()
            } catch (e) {
                showAlertError('Unknown Error - Logout Error')
            }
        }
        
        setConfirmLogout(false)
    }
    
    const getGmailCheck = async () => {
        try {
            const res = await apiRequest('get', endpoints.autoreply_gmail_check, {
                token: token
            })
            setGmailCheck(res.data.active)
            setGmailExpiry(Math.round((res.data.expiry - Date.now()) / 6000) / 10)
        } catch (e) {
            showAlertError('Unknown Error - Login Check Error')
        }
    }
    
    const gmailAuthComplete = () => {
        console.log('AUTH')
        getGmailCheck()
    }
    
    useEffect(() => {
        getList()
    }, [perpage])
    
    useEffect(() => {
        dispatch(setHeader({
            title: 'Email Autoreply'
        }))
        
        getList()
        getGmailCheck()
        
        if (authWindowInterval) {
            clearInterval(authWindowInterval)
        }
        authWindowInterval = setInterval(() => {
            if (authWindow) {
                if (authWindow.closed) {
                    getGmailCheck()
                    authWindow = false
                }
            }
        }, 1000)
    }, []);

    const showAlertError = (message) => {
        props.showAlert(message, 'error')
    }

    const showAlertSuccess = (message) => {
        props.showAlert(message, 'success')
    }

    return (
        <Grow in={list ? true : false}>
            <Stack sx={{ maxWidth: 1200, margin: 'auto', overflow: 'hidden', marginTop: '20px' }}>
                <AutoreplyTable
                    items={list}
                    pagination={pagination}
                    handlePaginate={handlePaginate}
                    handleChangePerpage={handleChangePerpage}
                    onRefresh={refreshHandler}
                    btnViewHandle={(item) => {setDetailsItem(item)}}
                    btnDeleteHandle={(item) => {setDeleteItem(item)}}
                    headerContent={
                        (<Stack direction="row" spacing={2} sx={{flexGrow:1}}>
                            <IconButton 
                                size="small" 
                                sx={{mb:-0.5}} 
                                onClick={() => {getList()}}
                            >
                                <ReplayIcon />
                            </IconButton>
                            <Stack sx={{flexGrow:1}}/>
                            <Button 
                                variant="contained" 
                                color="secondary"
                                startIcon={<ScheduleIcon />}
                                onClick={() => {setWorkTime({})}}
                            >
                                Settings
                            </Button>

                            {gmailCheck ?
                            <Button 
                                variant="contained" 
                                color="warning" 
                                startIcon={<GoogleIcon />} 
                                onClick={() => {setConfirmLogout(true)}}
                            >
                                Gmail Logout
                            </Button>
                            :
                            <Button 
                                variant="contained" 
                                color="success" 
                                startIcon={<GoogleIcon />} 
                                onClick={gmailLoginHandle}
                            >
                                Gmail Login
                            </Button>
                            }
                            <Button 
                                variant="contained" 
                                startIcon={<BugReportIcon />} 
                                onClick={() => {setTest(true)}}
                            >
                                AI Test
                            </Button>
                        </Stack>)
                    }
                />

                <Confirmation data={deleteItem} onResponse={deleteHandle} />
                <Warning text={warningText} onClose={() => {setWarningText(null)}} />
                <AutoreplyTestModal data={test} onClose={() => {setTest(false)}} />
                <AutoreplyDetailsModal data={detailsItem} onClose={() => {setDetailsItem(null)}} />
                <AutoreplySettingsModal data={workTime} onClose={() => {setWorkTime(null)}} />
                <Confirmation data={confirmLogout} onResponse={confirmLogoutHandle} />
                {loading ? <Loading/> : null}
            </Stack>
        </Grow>
    );
}

export default withAlert(AutoreplyEmail)